/* NAVIGATION COMPONENT *******************************************************/

import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Actions */
import { setView } from 'react-redux/actions/app'

import * as VIEW from 'component/app/view'

/* Styles */
import "./navigation.css"

/* Main App Navigation Component */
class Navigation extends Component {

  onNotificationClick(e) {
    const { setView } = this.props
    setView(VIEW.NOTIFICATION)
  }

  getClassName(elementView) {
    const { t, view } = this.props
    if (elementView === view) {
      return "label active"
    }
    return "label"
  }

  renderAdministration() {
    const { isSuperUser, t, setView } = this.props
    if (!isSuperUser) return
    return (
      <li>
        <a
          className={ this.getClassName(VIEW.ADMIN) }
          onClick={ () => setView(VIEW.ADMIN) }
          title={ t("navigation:admin.title") }
          >
          { t("navigation:admin.label") }
        </a>
      </li>
    )
  }

  renderImprint() {
    const { t, view, setView } = this.props
    return (
      <li>
        <a
          className={ this.getClassName(VIEW.IMPRINT) }
          onClick={ () => {setView(VIEW.IMPRINT)} }
        >
          { t('app:imprintLink') }
        </a>
      </li>
    )
  }


  renderLogin() {
    const { t, loggedIn, view, setView } = this.props
    if (loggedIn) return null
    //if (view === VIEW.LOGIN) className.push("selected")
    return (
      <li>
        <a
          className={ this.getClassName(VIEW.LOGIN) }
          onClick={ () => {setView(VIEW.DASHBOARD)} }
          >
          { t('app:loginLink') }
        </a>
      </li>
    )
  }

  renderDashboard() {
    const { t, view, setView } = this.props
    return (
      <li>
        <a
          className={ this.getClassName(VIEW.DASHBOARD) }
          onClick={ () => setView(VIEW.DASHBOARD) }
          title={ t("navigation:dashboard.title") }
        >
          { t("navigation:dashboard.label") }
        </a>
      </li>
    )
  }

  renderNotification() {
    const { t, view, setView } = this.props
    return (
      <li>
        <a
          className={ this.getClassName(VIEW.NOTIFICATION) }
          onClick={ () => setView(VIEW.NOTIFICATION) }
          title={ t("navigation:notification.title") }
        >
          { t("navigation:notification.label") }
        </a>
      </li>
    )
  }

  render() {
    const { t, loggedIn, view, setView } = this.props
    return (
      <div className="navigation component">
        <ul>
          { this.renderLogin() }
          { loggedIn && this.renderDashboard() }
          { loggedIn && this.renderNotification() }
          { loggedIn && this.renderAdministration() }
          { this.renderImprint() }
        </ul>
      </div>
    )
  }
}


Navigation.propTypes = {}

function mapStateToProps(state) {
  return {
    loggedIn: state.user.loggedIn,
    view: state.app.view,
    isSuperUser: state.user.isSuperUser
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setView
    },
    dispatch
  )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(Navigation)
const translatedComponent = translate(
    ['app'], { withRef: true }
)(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/navigation/navigation.jsx